// src/pages/ComingSoon.jsx
import React from 'react';
import PageContainer from '../components/PageContainer';

function ComingSoon() {
  return (
    <PageContainer>
      <h2>Coming Soon:</h2>
      <h1>HÄL Duo </h1>
      <p>We're working hard on this feature. Please check back later!</p>
    </PageContainer>
  );
}

export default ComingSoon;
